import { gql } from "apollo-boost";

const SOCIAL_LOGIN = gql`
  mutation ($input: SocialLoginInput!) {
    socialLogin(input: $input) {
      refresh_token
      access_token
      expires_in
      token_type
      user {
        id
        email
        arranger {
          id
        }
      }
    }
  }
`;

const LOGOUT_QUERY = gql`
  mutation logout {
    logout {
      status
      message
    }
  }
`;

const FORCE_LOGOUT = gql`
  mutation forceLogout($input: forceLogoutInput) {
    forceLogout(input: $input) {
      status
      message
    }
  }
`;
const FORCE_LOGOUT_PHONE_EMAIL = gql`
  mutation forceLogoutPhoneEmail($input: forceLogoutPhoneEmailInput) {
    forceLogoutPhoneEmail(input: $input) {
      status
      message
    }
  }
`;

export { SOCIAL_LOGIN, LOGOUT_QUERY, FORCE_LOGOUT, FORCE_LOGOUT_PHONE_EMAIL };
